import { render, staticRenderFns } from "./AtivoSelectComponent.vue?vue&type=template&id=79d52f80"
import script from "./AtivoSelectComponent.vue?vue&type=script&lang=js"
export * from "./AtivoSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports